/**
 * Render AGNÓSTICO de un diff a nivel de palabra (historial de versiones).
 *
 * Pinta los segmentos de `diffWords` con resaltado theme-aware:
 *   · añadido (está en el texto NUEVO) → fondo success suave
 *   · eliminado (solo en el viejo)     → fondo danger suave + tachado
 * Reutilizable para cualquier entidad versionada (guía VERSION_HISTORY).
 */
import { createMemo, For, Match, Switch } from "solid-js";
import { diffWords } from "@mealplan/shared";

interface WordDiffProps {
  /** Texto de la versión antigua. */
  oldText: string;
  /** Texto actual (referencia del diff). */
  newText: string;
  class?: string;
}

export function WordDiff(props: WordDiffProps) {
  const segments = createMemo(() => diffWords(props.oldText, props.newText));
  return (
    <p
      class={`whitespace-pre-wrap break-words text-sm leading-[1.75] text-foreground ${props.class ?? ""}`}
      data-testid="word-diff"
    >
      <For each={segments()}>
        {(segment) => (
          <Switch fallback={segment.text}>
            <Match when={segment.type === "added"}>
              <ins class="rounded-sm bg-success/20 px-0.5 no-underline" data-diff="added">
                {segment.text}
              </ins>
            </Match>
            <Match when={segment.type === "removed"}>
              <del
                class="rounded-sm bg-danger/10 px-0.5 text-muted-foreground line-through decoration-danger/50"
                data-diff="removed"
              >
                {segment.text}
              </del>
            </Match>
          </Switch>
        )}
      </For>
    </p>
  );
}
